import React, { Fragment } from "react";

const CompanyItem = ({
  setFilters,
  filters,
  setIsChecked,
  isChecked,
  item,
  index,
}) => {
  return (
    <Fragment>
      <div className="flex-only" key={index}>
        {filters.companyname === "" && (
          <div>
            <input
              type="checkbox"
              name="employer-name"
              className="job-type"
              value={item.companyname}
              onChange={(e) => {
                if (!isChecked.companyname) {
                  setFilters({ ...filters, companyname: e.target.value });
                  setIsChecked({ ...isChecked, companyname: true });
                } else {
                  setFilters({ ...filters, companyname: "" });
                  setIsChecked({ ...isChecked, companyname: false });
                }
              }}
            />
            <span className="job-type mt">{item.companyname}</span>
            <br />
          </div>
        )}
        {item.companyname === filters.companyname && (
          <div>
            <input
              type="checkbox"
              name="employer-name"
              className="job-type"
              checked
              value={item.companyname}
              onChange={(e) => {
                if (!isChecked.companyname) {
                  setFilters({ ...filters, companyname: e.target.value });
                  setIsChecked({ ...isChecked, companyname: true });
                } else {
                  setFilters({ ...filters, companyname: "" });
                  setIsChecked({ ...isChecked, companyname: false });
                }
              }}
            />
            <span className="job-type mt">{item.companyname}</span>
            <br />
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default CompanyItem;
